namespace Areas.MyWorkflows {
    "use strict";

    export function gotoWorkflows() {
        location.href = "/MyWorkflows/List/Review";
    }
       
    export function gotoViewFromForm() {
        const keyId: any = Areas.getOptionFromForm("WorkflowsForm", "KeyId");

        if (keyId != null) {
            location.href = `/Workflows/View/Index/${keyId}`;
        }
        else {
            DevExpress.ui.notify("Record not selected.  Use List instead!", "warning", 2000);
        }
    }

}

